'use client';

import {
  useRive,
  useViewModel,
  useViewModelInstance,
  useViewModelInstanceNumber,
  Layout,
  Fit,
} from '@rive-app/react-canvas';
import { useTheme } from 'next-themes';
import { useEffect } from 'react';

// Corpo / Corpo_light: state_select 1 (dark) or 8 (light)
const DARK_STATE = 1;
const LIGHT_STATE = 8;

const STATE_MACHINE = 'state_machine_01';
const VIEW_MODEL_NAME = 'ViewModel1';

interface PierreRiveIdleProps {
  className?: string;
}

export function PierreRiveIdle({ className = 'size-20' }: PierreRiveIdleProps) {
  const { resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === 'dark';

  const { rive, RiveComponent } = useRive({
    src: '/images/animations/pierre_loading.riv',
    stateMachines: STATE_MACHINE,
    autoplay: true,
    autoBind: false,
    layout: new Layout({ fit: Fit.Contain }),
  });

  const viewModel = useViewModel(rive, { name: VIEW_MODEL_NAME });
  const vmInstance = useViewModelInstance(viewModel, { rive });
  const { setValue: setStateSelect } = useViewModelInstanceNumber(
    'state_select',
    vmInstance,
  );

  useEffect(() => {
    if (!setStateSelect) return;
    setStateSelect(isDarkMode ? DARK_STATE : LIGHT_STATE);
  }, [setStateSelect, isDarkMode]);

  return <RiveComponent className={className} />;
}
